'use client';
import { useEffect, useRef } from 'react';

const GLOW_DURATION_MS = 5000;
const GLOW_INTERVAL_MS = 5 * 60 * 1000;

// Once scrolled into view the icons glow for 5s, then again every 5 minutes.
// The icons themselves are server-rendered children (see AiLogos.jsx), so this
// only swaps their glow classes instead of shipping the icon SVG data to the client.
export default function AiLogosGlow({ children }) {
  const rowRef = useRef(null);

  useEffect(() => {
    const row = rowRef.current;
    if (!row) return;
    let timeoutId;
    let intervalId;
    const setGlow = (on) => {
      row.querySelectorAll('a').forEach((a) => {
        a.classList.toggle('ai-icon-glow', on);
        a.classList.toggle('ai-icon-static', !on);
      });
    };
    const triggerGlow = () => {
      setGlow(true);
      clearTimeout(timeoutId);
      timeoutId = setTimeout(() => setGlow(false), GLOW_DURATION_MS);
    };

    const io = new IntersectionObserver(([entry]) => {
      if (!entry.isIntersecting) return;
      io.disconnect();
      triggerGlow();
      intervalId = setInterval(triggerGlow, GLOW_INTERVAL_MS);
    }, { threshold: 0.6 });
    io.observe(row);

    return () => {
      io.disconnect();
      clearTimeout(timeoutId);
      clearInterval(intervalId);
    };
  }, []);

  return (
    <div ref={rowRef} className="flex items-center justify-center gap-1.5 sm:gap-2">
      {children}
    </div>
  );
}
